/**
 * 首字母小写
 */

function firstLowerCase(s) {
    if (s && s.length) {
        s = s[0].toLowerCase() + s.substr(1);
    }
    return s
}

export default firstLowerCase
